// extracted by mini-css-extract-plugin
export default {"wrapper":"XIrz7","video":"V1jo5","text":"IW7rH","title":"OpMaV","description":"mGoJy","link":"agBGS"};